import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ap-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  searchQuery: string = "";
  isSearching = false;
  
  @Input() 
  public placeholder: string = "";

  @Input()
  public alignRight: boolean = false;

  @Input()
  public fullWidth: boolean = false;

  @Input()
  set query(value: string | null) {
    this.searchQuery = value || "";
    this.isSearching = !!value && value.length > 0;
  }

  @Output() onChange = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {

  }

  searchChange(evt: KeyboardEvent) {
    if (evt.key == 'Escape') {
      this.searchQuery = "";
      this.isSearching = false;
      this.cancelled.emit();
    } else if (this.searchQuery != "") {
        this.isSearching = true;
        this.emitChange();        
    } else {
      this.isSearching = false;
      this.cancelled.emit();
    }
  }

  emitChange() {
    if (this.searchQuery.length > 1) {
      this.onChange.emit(this.searchQuery);
    }
  }

  searchHasFocus() {

  }

  searchLostFocus() {
    this.isSearching = false;
    this.cancelled.emit();
  }

  cancelSearch() {
    this.isSearching = false;
    this.searchQuery = "";
    this.cancelled.emit();
  }

  hasSearchResults() {
   
  }
}
